export default __webpack_public_path__ + "static/media/insta-ico.22bda4c2.svg";